import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Layout from "components/Layout";
import DropDown from "components/DropDown";
import OrderTab from "pages/manage-orders/tabs";
import { ManageOrderTopHeading, OuterWrapper } from "assets/css/global";
import FilterModal from "components/FilterModal";
import HeadingIcon from "assets/svg/RequestOrderIcon";
import SearchIcon from "assets/svg/SearchIcon";
import FilterIcon from "assets/svg/FilterIcon";
import {
  ManageOrderWrapper,
  Heading,
  SearchWrapper,
  FilterWrapper,
  RightSection,
} from "styles/pages/manage-orders";
import { BodyContainer } from "styles/pages/global";
import { adminFetchLocationListApi } from "redux/actions/manageAccount";
import MultiSelect from "pages/invoicePage/headingSection/MultiSelect";
import MaterialToolTip from "components/MaterialToolTip";
import AlertModal from "components/AlertModal";
import { sortListOfObjects } from "helpers";
import { useText } from "locales/useGetText";
const ManageOrders = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locale = useText("manageOrder");
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  const loggedInUserInfo = JSON.parse(localStorage.getItem("loggedInUserData"));
  const token = loggedInUserInfo?.token;
  const customerId = loggedInUserInfo?.customerId;
  const [selectedFilter, setSlectedFilter] = useState("ASC");
  const [searchTextState, setSearchTextState] = useState("");
  const [filterPopUpModal, setFilterPopUpModal] = useState(false);
  const [locationsList, setLocationsList] = useState();
  const [multiSelectVal, setMultiSelectVal] = useState([]);
  const [locationIds, setLocationIds] = useState([]);
  const [currentTab, setCurrentTab] = useState(0);

  let toDate = new Date();
  let fromDate = new Date();
  toDate.setDate(toDate.getDate() + 90);
  fromDate.setDate(fromDate.getDate() - 20);
  const [getFromDate, setFromDate] = useState(
    fromDate.toISOString().substr(0, 10),
  );
  const [getToDate, setToDate] = useState(toDate.toISOString().substr(0, 10));

  const [orderType, setOrderType] = useState("");
  const [deliveryReq, setDeliveryReq] = useState("ALL");

  const toggleFilterModal = () => setFilterPopUpModal(!filterPopUpModal);

  useEffect(() => {
    if (!token) {
      navigate("/");
    } else {
      // setFromDate(fromDate.toISOString().substr(0, 10))
      // setToDate(getToDate.toISOString().substr(0, 10))
      fetchLocationListFunction();
    } //, getFromDate, getToDate
  }, []);

  let filterDropDown = [
    {
      label: locale("filterOldestRequestedDate"),
      value: "ASC",
    },
    {
      label: locale("filterNewestRequestedDate"),
      value: "DESC",
    },
  ];

  let statusArr = [
    { label: locale("statusRequested"), value: "REQUESTED" },
    { label: locale("statusAssigned"), value: "ASSIGNED" },
    { label: locale("statusDelivered"), value: "DELIVER_PICKUP" },
    { label: locale("statusCompleted"), value: "COMPLETE" },
    { label: locale("statusCancelled"), value: "CANCELLED" },
    { label: locale("statusClaimed"), value: "CLAIM" },
    { label: locale("statusAll"), value: "ALL" },
  ];

  const fetchLocationListFunction = async (type) => {
    let response = "";
    response = await dispatch(
      adminFetchLocationListApi(
        loggedInUserInfo?.locationType,
        customerId,
        token,
      ),
    );

    if (response?.success) {
      let mainLocationtemp = response?.data?.locations?.map(
        (val) => val.mainLocation,
      );
      let subLocationtemp = response?.data?.locations?.flatMap(
        (val) => val.subLocations || [],
      );
      let locationTemp = [...mainLocationtemp];
      if (subLocationtemp && subLocationtemp.length > 0) {
        locationTemp = [...mainLocationtemp, ...subLocationtemp];
      }
      locationTemp = sortListOfObjects(
        "string",
        locationTemp,
        "asc",
        "address.locationName",
      ); // sort alphabetically

      const arr = [
        { label: "All", value: "ALL" },
        ...locationTemp.map((location) => ({
          label: location.address.locationName,
          value: location.locationId,
        })),
      ];

      setLocationsList(arr);
      if (
        loggedInUserInfo?.locationType === "MAIN" ||
        loggedInUserInfo?.locationType === "PARENT_LOCATION"
      ) {
        setMultiSelectVal(arr[0]);
        let locationIdList = arr
          .filter((data) => data.value !== "ALL")
          .map((data) => data.value);
        setLocationIds(locationIdList);
      } else {
        let loginSubLocationID = loggedInUserInfo?.subLocationId;
        let tempSubLocValue = arr.filter(
          (data) => data.value === loginSubLocationID,
        );
        setMultiSelectVal(tempSubLocValue);
        setLocationIds([loginSubLocationID]);
      }
    } else {
      if (response?.data?.error?.message === "Invalid Token") {
        navigate("/");
      } else {
        setModalContent(
          response?.data?.error?.message ||
            response.message ||
            locale("genericErrorLater"),
        );
        setModalLink("");
        toggleModal();
      }
    }
  };

  const formFields = () => {
    return (
      <Layout activeTab="ManageOrder">
        <OuterWrapper>
          <ManageOrderTopHeading>
            <div className="icon-text-wrapper">
              <HeadingIcon />
              <Heading>
                <h4>{locale("manageOrders")}</h4>
                <span style={{ transform: "scale(.7)", marginTop: "1px" }}>
                  <MaterialToolTip
                    title={locale("manageOrdersTooltip30Days")}
                    class="passwordIcon"
                    infoIcon={true}
                  />
                </span>
              </Heading>
            </div>
            <RightSection>
              <div>
                <DropDown
                  name="filterDropDown"
                  data={filterDropDown}
                  className="responsive"
                  searchDropDown={selectedFilter}
                  searchable={true}
                  onChangeHandler={(val) => {
                    setSlectedFilter(val);
                  }}
                />
              </div>
              <div>
                <MultiSelect
                  data={locationsList}
                  placeholder={locale("selectLocation")}
                  multiSelectVal={multiSelectVal}
                  defaultValueArr={multiSelectVal}
                  setMultiSelectVal={(multiSelectVal) => {
                    // to check if all elements were selected
                    let isAllValuesSelected = false;
                    if (
                      multiSelectVal.length === locationsList.length ||
                      (multiSelectVal.length === locationsList.length - 1 &&
                        multiSelectVal.every((item) => item.value !== "ALL"))
                    )
                      isAllValuesSelected = true;

                    let tempMultiSelectVal = [],
                      tempLocationIds = [];
                    let result = multiSelectVal.map((item) => item.value);

                    const lastItem = multiSelectVal[multiSelectVal.length - 1];
                    if (
                      (lastItem && lastItem.value === "ALL") ||
                      isAllValuesSelected
                    ) {
                      tempMultiSelectVal = [{ label: "All", value: "ALL" }];
                      let locationIdList = locationsList
                        .filter((data) => data.value !== "ALL")
                        .map((data) => data.value);
                      tempLocationIds = locationIdList;
                    } else {
                      const index = result.indexOf("ALL");
                      if (index !== -1) {
                        result.splice(index, 1);
                      }
                      tempLocationIds = result;
                      tempMultiSelectVal = multiSelectVal.filter(
                        (data) => data.value !== "ALL",
                      );
                    }

                    setLocationIds(tempLocationIds);
                    setMultiSelectVal(tempMultiSelectVal);
                  }}
                  multi={true}
                />
              </div>
              <SearchWrapper className="responsive">
                <input
                  type="text"
                  placeholder={locale("search")}
                  value={searchTextState}
                  onChange={(e) => {
                    setSearchTextState(e.target.value);
                  }}
                />
                <SearchIcon className="search-icon" />
              </SearchWrapper>

              <FilterWrapper onClick={toggleFilterModal}>
                <FilterIcon />
              </FilterWrapper>
            </RightSection>
          </ManageOrderTopHeading>

          <ManageOrderWrapper>
            <OrderTab
              sort={selectedFilter}
              search={searchTextState}
              getFromDate={getFromDate}
              getToDate={getToDate}
              orderType={orderType}
              deliveryReq={deliveryReq}
              locationIds={locationIds}
              locale={locale}
              callBack={(val) => {
                // setFromDate(fromDate.toISOString().substr(0, 10))
                // setToDate(toDate.toISOString().substr(0, 10))
                setCurrentTab(val);
                setOrderType(statusArr[val].value);
              }}
            />
          </ManageOrderWrapper>
        </OuterWrapper>

        <FilterModal
          isOpen={filterPopUpModal}
          toggle={toggleFilterModal}
          title={locale("filterBy")}
          className="alert-msg-container"
          InnerClassName="alert-msg"
          currentTab={currentTab}
          callBackFun={(fromDate, toDate, orderStatus, deliveryReq) => {
            setFromDate(fromDate);
            setToDate(toDate);
            setOrderType(orderStatus);
            setDeliveryReq(deliveryReq);
          }}
        />

        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title={locale("alert")}
          content={modalContent}
          link={modalLink}
          className="alert-msg-container"
          InnerClassName="alert-msg"
        />
      </Layout>
    );
  };

  return <BodyContainer>{formFields()}</BodyContainer>;
};

export default ManageOrders;
